const isNonNullable = val => {
  return val !== undefined && val !== null;
};
export default isNonNullable;